<template>
  <v-container>
    <v-row>
      <v-col cols="10">
        <p class="person-index ml-1"> {{ insuranceType }} </p>
      </v-col>
      <v-col cols="2">
        <v-btn icon color="primary" @click="removeAssurance()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-if="!readonly"
      v-model="name"
      :label="$t('insurance.name')"
      filled
      class="required"
      :rules="[rules.required]">
    </v-text-field>
  </v-container>
</template>
<script>
import { requiredRule } from '@/helpers/validationRules';

export default {
  data() {
    return {
      name: this.insurance.name,
      rules: {
        required: requiredRule
      }
    };
  },
  props: {
    insuranceType: { type: String, required: true },
    insurance: { type: Object, required: true },
    readonly: { type: Boolean, required: false }
  },
  computed: {
    updateData() {
      const { name, street, zip_code, city } = this;
      return { name, street, zip_code, city };
    }
  },
  watch: {
    updateData: {
      handler() {
        this.$emit('input', {
          name: this.name
        });
      },
      deep: true
    }
  },
  methods: {
    removeAssurance() {
      this.$emit('removeInsurance');
    }
  }
};
</script>
